module.exports = __webpack_public_path__ + "static/media/modules.b26c33f0.png";